<template>
  <div class="container">
    <mt-header fixed :title="title" class="head">
      <div slot="left" @click="toBackClick">
        <mt-button icon="back"></mt-button>
      </div>
      <div slot="right" class="c_right" v-show="isOpera">
        <div class="c_right c_item_center" @click="saveClick">保存</div>
      </div>
    </mt-header>
    <div class="search-input" @click="selectClick">
      <div class="search c_flex_1 c_p_r_10" :class="!isInput?'':'c_no_pointer'">
        <input type="text" focus="true" :placeholder="tips" v-model="showValue" @input="inputChange"/>
      </div>
    </div>
    <div class="" style="height:15vw;width: 100%;"></div>
    <div id="reason" v-if="showValue == '上门未成交' || showValue == '不需要上门'">
      <mt-radio
        title="原因列表"
        v-model="reason"
        :options="reasonList">
      </mt-radio>
      <div>
        <p>备注:<input type="text" v-model="memo"></p>
      </div>

    </div>

    <!--工程列表-->
    <div class="loadmore-container">
      <!--<mt-loadmore :top-method="loadTop" ref="loadmore" :bottom-method="loadBottom"  :bottomDropText="params.bottomDropText"  :bottom-all-loaded="allLoaded">-->
      <mt-loadmore :top-method="loadTop" ref="loadmore" v-infinite-scroll="scroll_load"
                   :infinite-scroll-disabled="loading" infinite-scroll-distance="1">
        <div v-for="(n,index) in list" :key='index' class="c_m_t_10 bg_white form" @click="todetails(n)">
          <!--待接单-->
          <div class="c_size_11 c_flex_1 c_nowrap" v-if="Number(n.servicestate)==0">
            <div class="new">最新</div>
            <div class=" c_size_12 c_black code c_p_lr">{{n.vbillcode}}</div>
            <!--<div class="c_m_t_10">工程状态：<span :class="(n.servicestate==1?'c_blue':'c_gray')">{{n.servicestate==0?'待接单':(n.servicestate==2?'已完工':'施工中')}}</span></div>-->
            <div class="c_nowrap c_m_t_10  c_p_lr" v-show="n.servicestate != 0 && n.name">姓名：{{n.name}}</div>
            <div class="c_nowrap c_m_t_10  c_p_lr c_flex">
              <span class="c_gray_dark">地址：</span>
              <span class="c_black c_flex_1 c_nowrap_normal">{{n.province}}{{n.city}}{{n.district}}{{n.address}}</span>
              <span class="c_gray" v-if='n.community'></span>
              <!--<span  v+-show="n.community" class="c_gray_dark">小区：</span><span v-show="n.community" class="c_black">{{n.community}}</span>-->
            </div>
            <!--维修部位 面积 计划工期-->
            <div class="c_nowrap c_m_t_10 c_p_lr" v-if='n.part || n.area'>
              <span class="c_gray_dark" v-if='n.part'>维修部位：</span><span class="c_black"
                                                                        v-if='n.part'>{{n.part}}</span><span
              class="c_gray" v-if='n.area&&n.part'>&nbsp;&nbsp;|&nbsp;&nbsp;</span>
              <span class="c_gray_dark" v-if='n.area'>面积：</span><span class="c_black"
                                                                      v-if='n.area'>{{n.area}}㎡</span><span
              class="c_gray" v-if="n.servicestate==1 && n.planneddate">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
              <span>
                  <span class="c_gray_dark" v-if="n.servicestate==1 && n.planneddate">计划工期：</span>
                  <span v-if="n.servicestate==1 && n.planneddate" class="c_black">{{ n.planneddate}} 天</span>
              </span>
            </div>
            <!--创建时间 勘察时间-->
            <div class="c_nowrap c_m_t_10 c_flex_between c_p_lr">
              <span><span class="c_gray_dark">创建：</span><span
                class="c_black">{{ n.createtime | getDatetime }}</span></span>
              <span>
                <!--<span class="c_gray_dark" v-show="selected<1 && n.surveydate">勘察：</span>-->
                <!--<span class="c_black" v-show="selected<1 && n.surveydate">{{ n.surveydate | getDatetime }}</span>-->
              </span>
            </div>
          </div>
          <!--施工中-->
          <div class="c_size_12 c_flex_1 c_nowrap info" v-else>
            <div class="c_size_15 c_black"> {{n.vbillcode}}</div>
            <div class="c_size_15 c_black c_nowrap c_m_t_10" v-show="n.servicestate != 0 && n.name">{{n.name}}</div>
            <div class="c_nowrap c_m_t_10 c_black" v-show="n.servicestate != 0 && n.phone">手机号码：{{n.phone}}</div>
            <div class="c_nowrap c_m_t_10 c_black" v-if="Number(n.servicestate)==-2 || Number(n.servicestate)==-3">
              工程状态：{{n.servicestate | filter_servicestate}}
            </div>
            <div class="c_flex c_m_t_10 c_black">
              <span>施工地址：</span>
              <span class="c_flex_1 c_nowrap_normal">{{n.province}}{{n.city}}{{n.district}}{{n.address}}</span>
            </div>
            <div class="c_nowrap c_m_t_10 c_gray_drak planeDate">计划工期：{{ n.startdate | getYmd }} - {{ n.planneddate |
              getYmd}}
            </div>
          </div>

          <div class="opera c_flex c_flex_center" v-if="Number(n.servicestate) == 0">
            <!--<div class='confirm'>-->
              <!--<div style='float:left'><span class="c_orange">待接单</span></div>-->
              <!--<div class="bg_gray c_white" @click="acceptClick('N',n.billid)">拒绝</div>-->
              <!--<div class="bg_blue c_white" @click="acceptClick('Y',n.billid)">接受</div>-->
            <!--</div>-->
          </div>
          <div class="around c_flex supper" v-else>
            <div class="c_m_r_10 bg_gray_light c_white" v-if="n.supervisor">{{n.supervisor.charAt(0)}}</div>
            <div class="c_m_r_10 bg_gray_light c_white" v-if="n.constructionname">{{n.constructionname.charAt(0)}}</div>
          </div>

        </div>

        <div class="c_size_10 c_gray c_p_10 c_center c_flex c_flex_center" v-show="showLoading">
          <mt-spinner type="snake" color="#00ccff" :size="20" v-show="!stopload"></mt-spinner>
          <span v-show="stopload">已经是最后一页了</span>
        </div>
      </mt-loadmore>
    </div>

    <!--选择年月日-->
    <div class="select_date">
      <mt-datetime-picker
        ref="picker_date"
        type="date"
        year-format="{value}年"
        month-format="{value}月"
        date-format="{value}日"
        @confirm="confirm_date"
        v-model="select_date.date">
      </mt-datetime-picker>
      <mt-datetime-picker
        ref="picker_time"
        type="time"
        @confirm="confirm_time"
        v-model="select_date.time">
      </mt-datetime-picker>
    </div>

    <!--  选择工程状态  -->
    <mt-actionsheet
      :actions="servicestate_params.actions"
      v-model="servicestate_params.servicestate_visible">
    </mt-actionsheet>

  </div>
</template>

<script>
  import {Indicator, Toast, MessageBox} from 'mint-ui';

  export default {
    name: "search",
    data: function () {
      return {
        reason:'',
        reasonList:[],
        memo:'',
        //未上门原因



        // 页面头内容
        title: '',
        // 是否需要保存按钮
        isOpera: false,
        // input 的显示值
        showValue: '',
        //input 的所有数据
        realObj: {},
        // placeholder
        tips: "",
        // 是否是输入框
        isInput: false,
        // 如果不是输入框，提供选择类型
        // date 选择日期+时间， servicestate选择工程状态
        // list 查询显示列表
        inputType: 'date',

        // 日期
        select_date: {
          date: '',
          time: ''
        },
        // 选择工程状态
        servicestate_params: {
          servicestate_visible: false,
          actions: [
            {
              name: '上门未成交',
              state: '-3',
              method: this.servicestateClick,
            },
            {
              name: '不需要上门',
              state: '-2',
              method: this.servicestateClick,
            },
          ],
        },
        //是否填写过勘察表单
        hassurvey:false,
        note:null,
        // 无限滚动
        list: [],
        loading: false,
        showLoading: false,
        stopload: false,
        //工程参数
        params: {
          pageIndex: 0,
          pageSize: 10,
          totalPages: 1,
          servicestate: 1,   // 施工中 1 ， 已完工 2
          bottomDropText: '释放加载',
        },
        sort:{},
      }
    },
    mounted: function () {
      // type ,  筛选返回参数 back,  直接选择提交 ajax,  显示列表 select
      let type = this.$route.params.type;
      let isOpera = this.$route.params.isOpera || false;
      let api = this.$route.params.api || false;
      let tips = this.$route.params.tips || '';
      let val = this.$route.params.val || '';
      let title = this.$route.params.title || '';
      let isInput = this.$route.params.isInput || false;
      let inputType = this.$route.params.inputType || '';
      if (type) {
        this.type = type;
        this.isOpera = isOpera;
        this.api = api;
        this.tips = tips || (type == 'back' ? '搜索' : '请输入');
        this.showValue = val;
        this.title = title;
        this.isInput = isInput;
        this.inputType = inputType;
        if (inputType == 'servicestate') {
          this.servicestateClick({"state": val});
        }
      } else {
        this.$router.go(-1);
      }
      this.getSort();
    },
    methods: {
      inputChange: function () {
        if (this.type == 'select') {
          this.params.pageIndex = 0;
          this.setSort(this.showValue);
          this.searchProject();
        }
      },
      saveClick: function () {
        let $that = this;
        let val = this.showValue;
        let type = this.type;
        let api = this.api;
        if (type == 'ajax') {
          var obj = {};
          if (api == 'editUserName') {  //修改姓名
            obj.type = 'name';
            obj.data = val;
            // api = '/simpleuser/commit';
            api = this.$$api.mobile.editUserInfo;
            this.postValue(api, obj);
          } else if (api == 'editUserPhone') { //修改手机号
            obj.type = 'phone';
            obj.data = val;
            // api = '/simpleuser/commit';
            api = this.$$api.mobile.editUserInfo;
            this.postValue(api, obj);
          } else if (api == 'editSurveydate') {
            obj.key = 'surveydate';
            obj.value = val;
            obj.dealid = JSON.parse(localStorage['obj']).dealid;
            api = this.$$api.mobile.editSurveydate;
            this.postValue(api, obj, function () {
              var obj_session = localStorage['obj'];
              if (obj_session) {
                obj_session = JSON.parse(obj_session);
              } else {
                obj_session = {};
              }
              obj_session.surveydate = val;
              localStorage['obj'] = JSON.stringify(obj_session);
              $that.$router.go(-1);
            });
          } else if (api == "editServicestate") {
            var value = $that.reason;
            var memo = $that.memo;
            // MessageBox.prompt('请输入备注11').then(({value, action}) => {

//               if (action == 'confirm') {
                if (value || $that.showValue == '进行中') {
                  value = value.substring(0, 45);
                  var obj = {};
                  obj.key = "servicestate";
                  obj.value = String($that.realObj.val);
                  obj.dealid = JSON.parse(localStorage['obj']).dealid;
                  obj.memo = $that.memo;  //备注内容
                  obj.type = $that.reason; //原因
                  api = this.$$api.mobile.editSurveydate;
                  this.postValue(api, obj, function () {
                    var obj_session = localStorage['obj'];
                    if (obj_session) {
                      obj_session = JSON.parse(obj_session);
                    } else {
                      obj_session = {};
                    }
                    obj_session.servicestate = String($that.realObj.val);
                    localStorage['obj'] = JSON.stringify(obj_session);
                    $that.$router.push('/main');
                  });
                } else {
                  Toast("请输入原因");
                }
              }
            // });
          }
        // } else if (type == 'back') {
        //
        // }
      },
      postValue: function (api, obj, fun) {
        let $that = this;
        Indicator.open();
        this.$ajax.post(api, obj, response => {
          Indicator.close();
          if (response.status >= 200 && response.status < 300) {
            if (fun) {
              fun();
            } else {
              $that.$router.go(-1);
            }
          } else {
          }
        });
      },
      toBackClick: function () {
        this.$router.go(-1);
      },

      // 选择框列表
      selectClick: function () {
        // isOpera=true&title="选择时间"&isInput=false&type=ajax&inputType=date&api=editSurveydate
        if (this.isInput) {
          if (this.inputType == 'date') {
            // 选择日期+时间
            var old_date;
            if (!this.showValue) {
              old_date = new Date();
            } else {
              if (this.showValue.indexOf('-') != -1) {
                this.showValue = this.showValue.replace(/-/g, '/');
              }
              old_date = new Date(this.showValue);
            }
            this.select_date.date = old_date;
            this.select_date.time = old_date.getHours() + ':' + old_date.getMinutes() + ':' + old_date.getSeconds();
            this.$refs.picker_date.open();
          } else if (this.inputType == "servicestate") {
            // 选择 工程状态
            this.servicestate_params.servicestate_visible = true;
            //判断是否填写过勘察表单
            this.hasSurvey();
          }
        }
      },
      hasSurvey:function () {
        var $that = this;
        var billid = JSON.parse(localStorage['obj']).billid;
        this.$indicator.open();
        this.$ajax.get(this.$$api.mobile.getProcedureList, {
          billid: billid,
          type: '业务',
        }, function (res) {
          if (res.status == 200) {
            var list = res.data.detailMsg.data;
            var hassurvey = false ;
            for(var item of list){
              if(item.state == 2){
                hassurvey = true
              }
            }
            $that.hassurvey = hassurvey;
          } else {
            $that.$toast(res.data.msg);
          }
          $that.$indicator.close();
        });
        //获取note
        this.$indicator.open();
        this.$ajax.get(this.$$api.mobile.getNote, {
          billid: billid,
        }, function (res) {
          if (res.status == 200) {
            $that.note = res.data.detailMsg.data;

          } else {
            $that.$toast(res.data.msg);
          }
          $that.$indicator.close();
        })
      },
      // 选择工程状态
      servicestateClick: function (obj) {

        var text;
        obj.state = String(obj.state);
        if(obj.state == '-2'){ //不需要上门
          if(this.hassurvey && this.note != '3'){
            this.$toast('已填写勘察单，不能选择不需要上门！');
            return
          }
        }

        if(obj.state == '-3'){ //上门未成交        console.log(1)
          if(!this.hassurvey){
            this.$toast('未填写勘察单，不能选择上门未成交！');
            return
          }
        }

        switch (obj.state) {
          case "-3":
            text = "上门未成交";
            break;
          case "-2":
            text = "不需要上门";
            break;
          case "0":
            text = "未开工";
            break;
          case "1":
            text = "进行中";
            break;
          case "2":
            text = "已完成";
            break;
          default:
            text = "未开工";
        }
        var realObj_temp = {};
        realObj_temp.showValue = text;
        realObj_temp.val = obj.state;
        this.showValue = text;
        this.realObj = realObj_temp;

        //请求原因列表
        var $that = this;
        var search_parentid;
        if(obj.state == -2){ //不需要上门
          search_parentid = 'cd4b7b4f-0faf-4eb7-9294-c463968c1087';
        }else if(obj.state == -3){ //上门未成交
          search_parentid = '907757a6-f92b-42bf-89cb-63612d139c03';
        }
        if(search_parentid){
          this.$ajax.get(this.$$api.mobile.getReasonList, {
            'pageIndex': 0,
            'pageSize': 20,
            'sortDirection': 'desc',
            'sortField': 'ts',
            'search_parentid': search_parentid
          }, function (res) {
            if (res.status == 200) {
              var data = res.data.detailMsg.data.content;
              if(data){
                var arr = [];
                for(var i=0;i<data.length;i++){
                  var obj = {};
                  obj.label = data[i].value;
                  obj.value = data[i].value;
                  arr.push(obj);
                }
                $that.reasonList = arr;
              }
            }
            $that.$indicator.close();
            $that.loading = false;
            if(fun)fun();
          })
        }
      },

      //搜索工程
      searchProject: function (fun) {
        var $that = this;
        if (!(this.type == 'select')) {
          return;
        }
        this.$indicator.open();
        this.$ajax.get(this.$$api.mobile.getServiceList, {
          'pageIndex': $that.params.pageIndex,
          'pageSize': $that.params.pageSize,
          'sortDirection': 'desc',
          'sortField': 'ts',
          'search_servicestate':1,
          'search_userinfo':this.showValue
        }, function (res) {
          if (res.status == 200) {
            var msg = res.data.detailMsg.data;
            var pageIndex = msg.number;
            var totalPages = msg.totalPages;
            var list = msg.content;
            if (pageIndex == 0) {
              $that.list = list;
            } else if (pageIndex < totalPages) {
              $that.list = $that.list.concat(list);
            }
            $that.params.pageIndex = pageIndex + 1;
            $that.params.totalPages = totalPages;
          }
          $that.$indicator.close();
          $that.loading = false;
          if(fun)fun();
        });
      },
      // 无限滚动
      scroll_load:function () {
        if(this.loading){
          return;
        }
        if (!(this.type == 'select')) {
          return;
        }
        this.loading = true;
        this.showLoading = true;
        var $that = this;
        var pageIndex = $that.params.pageIndex;
        var totalPages = $that.params.totalPages;
        if(pageIndex >= totalPages){
          // 已经到最后一页了
          this.stopload = true;
          setTimeout(function () {
            $that.showLoading = false;
            $that.loading = false;
          },2500);
        }else{
          this.stopload = false;
          $that.searchProject(function () {
            $that.showLoading = false;
            $that.loading = false;
          });
        }
      },
      loadTop:function(){
        var $that = this;
        if (!(this.type == 'select')) {
          return;
        }
        this.params.bottomDropText = '释放加载';
        this.params.pageIndex = 0;
        this.searchProject(function () {
          setTimeout(function () {
            $that.$refs.loadmore.onTopLoaded();
          })
        });
      },
      todetails:function(msg){
        if (!(this.type == 'select')) {
          return;
        }
        var id = msg.billid;
        // var selected = this.selected;
        var selected = msg.servicestate;
        if(selected >0){
          if(!id || ( selected < 1 ))return;
          var obj = {};
          obj.name = msg.name;
          obj.avatar = msg.avatar;
          obj.phone = msg.phone;
          obj.billid = msg.billid;
          obj.surveydate=msg.surveydate;
          obj.dealid=msg.dealid;
          obj.totalamount = msg.totalamount;
          obj.servicestate = msg.servicestate;
          obj.customerid = msg.customerid;
          localStorage['obj'] = JSON.stringify(obj);
          this.$router.push({path:'/imgupdate'});
        }
      },

      // sort
      setSort:function (value) {
        var obj = localStorage['sort'];
        if(obj){
          obj = JSON.parse(obj);
          obj.search = value;
          localStorage['sort'] = JSON.stringify(obj);
        }else{
          obj = {};
          obj.search = value;
          localStorage['sort'] = JSON.stringify(obj);
        }
      },
      getSort:function () {
        var obj = localStorage['sort'];
        if(obj){
          this.showValue = JSON.parse(obj).search;
        }
      },

      confirm_date: function () {
        var date = (new Date(this.select_date.date)).getTime();
        this.showValue = this.$comm.timeFormat(date);
        this.$refs.picker_time.open();
      },
      confirm_time: function () {
        var date = (new Date(this.select_date.date)).getTime();
        var time = (this.select_date.time).split(':');
        time = time[0] * 60 * 60 * 1000 + time[1] * 60 * 1000;
        this.showValue = this.$comm.timeFormat(date + time);
        this.select_date.date = date;
        this.select_date.time = time;
      },


    },

  }
</script>

<style scoped>
  .container {
    font-size: 4vw;
  }

  .search-input {
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 2.419vw;
    background: #e7e8e8;
    border-bottom: 1px solid #f7f7f7;
    height: 15vw;
    /*align-items:center;*/
    position: fixed;
    top: 60px;
    left: 0;
    z-index: 100;
    width: 100%;
  }

  .search-input input {
    width: 100%;
    height: 100%;
    border: none;
    outline: none;
    background: transparent;
    font-size: 4.065vw;
  }

  /*工程*/

  .c_size_15{
    font-size:4.2vw;
  }
  .c_size_12{
    font-size:3.7vw;
  }
  .c_size_12{
    font-size:3.5vw;
  }
  .form{
    margin:2vw 2vw 4vw;
    border-radius:1vw;
    position:relative;
    border:.2vw solid rgb(184,195,206);
    /*border:1px dotted rgb(3,162,228);*/
    padding:2vw;
    overflow: hidden;
  }
  .bg_gray_light{
    background: rgba(184,195,206,.7);
    border:none !important;
  }
  .info{
    width:100%;
  }
  .supper{
    position:absolute;
    top:2vw;
    right:0vw;
  }
  .c_gray_dark{
    color: rgb(108,125,135);
  }
  .around >div{
    border: 1px solid #ccc;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    border-radius: 50%;
    width: 10vw;
    height: 10vw;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .opera>div>div{
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    text-align: center;
    padding: 3vw 7.226vw;
    margin-top: 1.5vw;
    font-size: 3vw;
  }
  #reason div{
    background: #fff;
    padding-top: 20px;
  }
  #reason p{
    font-size: 12px;
    color:rgb(136, 136, 136);
    margin-left:10px;
  }
  #reason input{
    margin-left:20px;
    border:1px solid rgb(217, 217, 217);
    width:80%;
    height:25px;
    border-radius: 2px;
    margin-bottom:20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/search.vue